import React, { forwardRef } from "react";

const Checkbox = forwardRef(
  (
    { label, value = false, onChange, id, disabled = false, className = "" },
    ref
  ) => {
    return (
      <div className={`custom-checkbox ${className}`}>
        <input
          type="checkbox"
          id={id}
          checked={value}
          onChange={onChange}
          disabled={disabled}
          className="custom-checkbox__input"
          ref={ref}
        />
        <label htmlFor={id} className="custom-checkbox__label">
          <span className="custom-checkbox__box">
            {value && (
              <svg
                className="custom-checkbox__icon"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  fill="white"
                  d="M20.285 6.709l-10.285 10.292-4.285-4.292 1.415-1.415 2.87 2.877 8.864-8.877z"
                />
              </svg>
            )}
          </span>
          {label && <span className="custom-checkbox__text">{label}</span>}
        </label>
      </div>
    );
  }
);

export default Checkbox;
